import React, { createRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Table as ResTable, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import { Link } from 'react-router-dom';
import {
    FilterList,
    CircularLoading,
} from '../../Common';
import {
    Grid,
    Typography,
    Card,
} from '@mui/material';
import { trakrefFontFamily, trakrefFontFamilySemiBold } from '../../../utils';
import UserInfo from '../../../UserInfo';
import NoTableDataIcon from '../../../Icons/empty_table_placeholder.svg';
import { trakrefBlue } from '../../../color_utils';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import '../Table/Table.css';

const UITable = ({
    url,
    data,
    numberOfRows,
    refresh,
    filterOptions,
    columns,
    noResultText,
    noResultText2,
    showColumnHeaderFilter,
    loading,
}) => {
    const [smallLoading, setSmallLoading] = useState(true);
    const [rows, setRows] = useState(data);
    const [noData, setNoData] = useState(rows.length <= 0);
    const [sort, setSort] = useState(null);
    const [filters, setFilters] = useState(null);
    const [clearFilters, setClearFilters] = useState(null);
    const [filterListOptions, setFilterListOptions] = useState([]);
    
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(data.length / numberOfRows);
    const [resultCount, setResultCount] = useState(data.length);
    const [rowCount, setRowCount] = useState(numberOfRows);
    const [createFilter, setCreateFilter] = useState(false);
    const [showSelectColumns, setShowSelectColumns] = useState(false);
    const [showSelectColumnsList, setShowSelectColumnsList] = useState([]);
    const [wrapperRef, setWrapperRef] = useState(createRef());
    const [selectedFilter, setSelectedFilter] = useState(null);

    // Determine filter options
    useEffect(() => {
        const filterListOptions = [];
        columns.map(column => {
            if (column.filter) {
                filterListOptions.push({
                    type: column.filter,
                    property: column.property,
                    name: column.title
                });
            }
        });
        setFilterListOptions(filterListOptions);
    }, []);
  
    useEffect(() => {
        let tempArray = JSON.parse(sessionStorage.getItem(url + "columns" + UserInfo.instanceId));

        if (tempArray) {
            setShowSelectColumnsList(tempArray);
        } else {
            // Find any columns
            columns.map(column => {
                if (column.whatever) {
                    showSelectColumnsList.push({
                        property: column.props.property,
                        title: column.props.title,
                        visible: column.props.visible == false ? false : true
                    });
                }
            });
            setShowSelectColumnsList(showSelectColumnsList);
        }
        // Bind event for clicks outside element
        document.addEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        setSmallLoading(false);
    }, [page, filters, refresh]);

    const headerClicked = (property) => {
        if (!property) return null;
        if (sort === property) {
            sessionStorage.setItem(url + "sort" + UserInfo.instanceId, JSON.stringify(property + '_desc'));
            setSort(property + '_desc');
        } else {
            sessionStorage.setItem(url + "sort" + UserInfo.instanceId, JSON.stringify(property));
            setSort(property);
        }

        sessionStorage.setItem(url + "page" + UserInfo.instanceId, JSON.stringify(1));
        setPage(1);
    };

    const handleFilterKeyUp = (evt) => {
        if (evt.keyCode == 13) {

            let tempArray = JSON.parse(sessionStorage.getItem(url + "filters" + UserInfo.instanceId));

            if (tempArray == null)
                tempArray = [...filters];

            let filter = {
                property: evt.target.id,
                name: filterListOptions.filter(f => f.property === evt.target.id)[0].name,
                type: "text",
                value: evt.target.value
            };

            evt.target.value = "";

            tempArray.push(filter);

            sessionStorage.setItem(url + "filters" + UserInfo.instanceId, JSON.stringify(tempArray));

            setFilters(tempArray);
            setSelectedFilter(null);

            sessionStorage.setItem(url + "page" + UserInfo.instanceId, JSON.stringify(1));
            setPage(1);

            setClearFilters(tempArray.length > 0 ? true : false);
        }
        
    };

    const handleFilterClick = evt => evt.stopPropagation();

    const handleClearFilters = (e) => {
        e.stopPropagation();
        sessionStorage.removeItem(url + "filters" + UserInfo.instanceId);
        setFilters([]);
        setClearFilters(false);
    };

    const changePage = (amount) => {
        sessionStorage.setItem(url + "page" + UserInfo.instanceId, JSON.stringify(page + amount));
        setPage(page + amount);
    };

    const changePageBackKeyboard = (e) => {
        if (e.keyCode == 13) {
            changePage(-1);
        }
    };

    const changePageForwardKeyboard = (e) => {
        if (e.keyCode == 13) {
            changePage(1);
        }
    };

    const changePageBack = () => changePage(-1);

    const changePageForward = () => changePage(1);

    const handleClickOutside = (event) => {
        if (wrapperRef && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setCreateFilter(false);
            setShowSelectColumns(false);
        }
    };

    const addSelectedColumn = (e, newColumn) => {
        const list = [...showSelectColumnsList];
        let col = list.find(f => f.property == newColumn.property);
        col.visible = !col.visible;

        setShowSelectColumnsList(list);
        
        sessionStorage.setItem(url + "columns" + UserInfo.instanceId, JSON.stringify(showSelectColumnsList));
    };

    const getColumn = (property) => {
        const errorTypes = [undefined, null];
        const foundColumn = showSelectColumnsList.find(f => f.property === property);
        // if column cannot be found, do not show the column
        if (errorTypes.includes(foundColumn)) {
            return {};
        }
        return foundColumn;
    };

    const ColumnCustomization = () => (
        <>
            <div className="action-buttons">

                <Link
                    onClick={() => setShowSelectColumns(!showSelectColumns)}
                    className="choosecolumns-button"
                    title="Customize Columns"
                >
                    <img
                        src="/images/ic_customize-table.svg"
                        alt="Customize Columns"
                    />
                </Link>
            </div>
            {showSelectColumns && (
                <div className="columns-choose cols-xs-12 col-md-3" ref={wrapperRef} >
                    <div className="createColumns-toptext">
                        <div className="createColumns-apply-text">
                            For an optimized experience, We recommend to add 4 columns max
                        </div>
                    </div>
                    <div className="columns-choose-choices">
                        {showSelectColumnsList.map((column) => (
                            column.property && (
                                <div className="filter-create-box col-xs-12 col-md-6" onClick={e => addSelectedColumn(e, column)}>
                                    <input type="checkbox" checked={column.visible} />
                                    {" " + column.title}
                                </div>
                            )
                        ))}
                    </div>

                    <div className="createColumns-apply">
                        <div className="createColumns-apply-text">
                            <Link onClick={() => setShowSelectColumns(false)}>
                                Apply
                            </Link>
                        </div>
                    </div>
                </div>
            )}
        </>
    );

    const FilterListContainer = () => (
        <div className="filter-row row no-margin">
            <FilterList
                tableURL={url}
                filters={filterListOptions}
                filterValues={filterOptions}
                appliedFilters={filters}
                setAppliedFilters={setFilters}
                filterListOpen={createFilter}
                setFilterListOpen={() => setCreateFilter(!createFilter)}
                selectedFilter={selectedFilter}
                setSelectedFilter={setSelectedFilter}
                clearFilters={clearFilters}
                handleClearFilters={handleClearFilters}
                setClearFilters={setClearFilters}
            />

            <ColumnCustomization />
        </div>
    );

    const NoData = () => (
        <Card variant='outlined'>
            <Grid container>
                <Grid item xs={12} align='center'>
                    <img
                        style={{ paddingTop: '4%' }}
                        src={NoTableDataIcon}
                        alt={noResultText}
                    />
                </Grid>
                <Grid item xs={12}>
                    {noResultText ? (
                        <Typography
                            variant='h5'
                            align='center'
                            style={{
                                marginTop: '2%',
                                paddingBottom: noResultText2 ? '.5%' : '2%',
                                color: '#1A173B',
                                fontFamily: trakrefFontFamilySemiBold,
                            }}
                        >
                            {noResultText}
                        </Typography>
                    ) : (
                        <Typography
                            variant='h5'
                            align='center'
                            style={{
                                marginTop: '2%',
                                paddingBottom: '2%',
                                color: '#1A173B',
                                fontFamily: trakrefFontFamilySemiBold
                            }}
                        >
                            No results to display. Reset filters to see more results
                        </Typography>
                    )
                    }
                </Grid>
                {noResultText2 && (
                    <Grid item xs={12}>
                        <Typography
                            variant='h5'
                            align='center'
                            style={{
                                paddingBottom: '2%',
                                color: '#1A173B',
                                fontSize: '1.25rem',
                                fontFamily: trakrefFontFamily
                            }}
                        >
                            {noResultText2}
                        </Typography>
                    </Grid>
                )}
            </Grid>
        </Card>
    );

    const TablePagination = () => (
        <div className="table-footer d-flex justify-content-center">
            {page > 1 && (
                <div tabindex="0" className="table-page-change" onClick={changePageBack} onKeyUp={changePageBackKeyboard} >
                    <img
                        src="/images/ic_arrow_left.svg"
                        width="7"
                        height="12"
                        viewBox="0 0 20 18"
                        className="table-svg"
                        alt="left"
                    />
                </div>
            )}
            <div className="col-2 d-flex justify-content-center">
                {(((page - 1) * rowCount) + 1) + '-' + ((page * rowCount) < resultCount ? (page * rowCount) : resultCount)} of {resultCount}
            </div>
            {page < pages && (
                <div tabindex="0" className="table-page-change" onClick={changePageForward} onKeyUp={changePageForwardKeyboard}>
                    <img
                        src="/images/ic_arrow_right.svg"
                        width="7"
                        height="12"
                        viewBox="0 0 20 18"
                        className="table-svg"
                        alt="right"
                    />
                </div>
            )}
        </div>
    );

    const Table = () => (
        <div className="table">
            <Card variant='outlined'>
                <ResTable>
                    <Thead>
                        <Tr className="table-columnheader">
                            {columns.map(column => (
                                <Th
                                    onClick={() => {
                                        if (column.sort) {
                                            headerClicked(column.property)
                                        } 
                                    }}
                                    className={(column.noSort ? 'noSort' : '') + (column.icon ? ' hasIcon' : '') + ((getColumn(column.property)).visible === false ? ' hideColumn' : '')}
                                >
                                    {column.title}

                                    {column.sort && column.property === sort && (
                                        <img src="/images/ic_arrow_down.svg" width="12" height="7" viewBox="0 0 20 18" className="table-svg" alt="Sort Ascending"/>
                                    )}
                                    {(column.sort && column.property + '_desc') === sort && (
                                        <img src="/images/ic_arrow_up.svg" width="12" height="7" viewBox="0 0 20 18" className="table-svg" alt="Sort Descending" />
                                    )}
                                </Th>
                            ))}
                        </Tr>
                    </Thead>
                    <Tbody>
                        {showColumnHeaderFilter && (
                            <tr className="table-columnheaderfilter">
                                {columns.map(column => (
                                    (column.property && (
                                        <Td
                                            onClick={e => headerClicked(column.property)} 
                                            className={((getColumn(column.property)).visible === false ? ' hideColumn' : '')}
                                        >
                                            {(column.property && column.filter) && (
                                                <input
                                                    type="text"
                                                    id={column.property}
                                                    onKeyUp={handleFilterKeyUp}
                                                    onClick={handleFilterClick}
                                                    autoComplete="false"
                                                    placeholder="Filter"
                                                />
                                            )}
                                        </Td>
                                    ))
                                ))}
                            </tr>
                        )}

                        {(smallLoading || loading) ? (
                            <tr>
                                <td colSpan={columns.length} style={{ height: rowCount*2.8 +'rem' }}>
                                    <CircularLoading />
                                </td>
                            </tr>
                        ) : (
                            rows
                            .slice((page - 1) * rowCount, page * rowCount)
                            // page = 1 --> slice from 0 to 11 --> 0 to 10 items
                            // page = 2 --> slice from 10 to 21 --> 10 to 20 items
                            // page = 3 --> slice from 20 to 31 --> 20 to 31 items
                            .map((row, index) => (
                                <Tr key={row['key']} className={((index % 2) === 0) ? 'even-row' : ''}>
                                    {columns.map(column => {
                                        const renderValue = row[column.property];
                                        const isLink = row[column.linkId];
                                        if (isLink) {
                                            let linkURL = row[column.linkId];
                                            if (column.contsructLink) {
                                                linkURL = `${column.linkPath}/${row[column.linkId]}`;
                                            }

                                            return (
                                                <Td
                                                    className=''
                                                    title={renderValue}
                                                >
                                                    <Link
                                                        target="_blank"
                                                        to={linkURL}
                                                        style={{ color: trakrefBlue }}
                                                    >
                                                        {renderValue}
                                                    </Link>
                                                </Td>
                                            );
                                        }
                                        return (
                                            <Td
                                                className=''
                                                title={renderValue}
                                            >
                                                <label
                                                    tabindex={renderValue === null ? "" : "0" }
                                                >
                                                    {renderValue}
                                                </label>
                                            </Td>
                                        );
                                    })}
                                </Tr>
                            ))
                        )}
                    </Tbody>
                </ResTable>

                <TablePagination />
            </Card>
        </div>
    );

    return (
        <div className="tablediv">
            {filterListOptions.length > 0 && <FilterListContainer />}
            {data.length > 0 && <Table />}
            {data.length <= 0 && <NoData />}
        </div>
    );
};

UITable.propTypes = {
    url: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    columns: PropTypes.array.isRequired,
    page: PropTypes.number,
    numberOfRows: PropTypes.number,
    refresh: PropTypes.bool,
    filterOptions: PropTypes.array,
    noResultText: PropTypes.string,
    noResultText2: PropTypes.string,
    showColumnHeaderFilter: PropTypes.bool,
    loading: PropTypes.bool,
};

UITable.defaultProps = {
    filterOptions: [],
    page: 1,
    numberOfRows: 10,
    refresh: false,
    noResultText: "No results to display.",
    noResultText2: "",
    showColumnHeaderFilter: false,
    loading: false,
};

export default UITable;
